import { htmlFrom } from "utils/functions";

const ForAgent = ({
  description
}) => {
  return (
    <>
      {
        description
          ? <div>{htmlFrom(description)}</div>
          : <div>Инструкция не добавлена</div>
      }
    </>
  );
};

export default ForAgent;